import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type ParamsType = {
  uid: string
  name: string | null
  thridPlatform: string
}

class FetchPchomeTokenApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_PCHOME_TOKEN'

    this.config = {
      url: `/v1/user-auth/3rd-platform`,
      method: 'GET',
      params,
    }
  }
}

export const fetchPchomeToken = (params: ParamsType) => getCallApiFunction(new FetchPchomeTokenApi(params))
